import _ from 'lodash';
export const getFeatureCoordinate = (feature, propName) => {
    if (!feature.properties) {
        return;
    }
    if (_.isString(feature.properties[propName])) {
        try {
            const doorCoordinates = JSON.parse(feature.properties[propName]);
            return doorCoordinates;
        }
        catch (e) {
            console.error('Error parsing door coordinates json: ', feature.properties[propName], e);
        }
    }
    if (_.isArray(feature.properties[propName]) && feature.properties[propName].length === 2) {
        return feature.properties[propName];
    }
    if (feature.properties[`${propName}_x`] && feature.properties[`${propName}_x`]) {
        const x = parseFloat(feature.properties[`${propName}_x`].toString());
        const y = parseFloat(feature.properties[`${propName}_y`].toString());
        return [x, y];
    }
    return;
};
export const getFeatureBoolean = (feature, propName) => {
    if (!feature.properties || !feature.properties[propName]) {
        return false;
    }
    return (feature.properties[propName] === true || feature.properties[propName] === 'true');
};
export const getFeatureIntegerArray = (feature, propName) => {
    if (!feature.properties || !feature.properties[propName]) {
        return [];
    }
    if (_.isString(feature.properties[propName])) {
        try {
            return JSON.parse(feature.properties[propName]);
        }
        catch (e) {
            console.error('Error parsing floor ids for stairs: ', feature.properties[propName], e);
        }
    }
    else if (_.isArray(feature.properties[propName]) && feature.properties[propName].length > 0) {
        return feature.properties[propName];
    }
    return [];
};
export const getFeatureLocationId = (feature) => {
    if (!feature.properties) {
        return 0;
    }
    if (feature.properties.loc_id) {
        return parseInt(feature.properties.loc_id.toString());
    }
    else if (feature.properties.location_id) {
        return parseInt(feature.properties.location_id.toString());
    }
    else if (feature.properties.id_location) {
        return parseInt(feature.properties.id_location.toString());
    }
    return 0;
};
